import { ESideBarContext } from '../../types';
import { getIconByContext } from '../../utils';
import React from 'react';

interface AppchargeIconProps {
  context: ESideBarContext;
  size?: number;
  isCheckout?: boolean;
}

const AppchargeIcon: React.FC<AppchargeIconProps> = ({
  context,
  size = 20,
  isCheckout
}) => {
  const renderIcon = () => {
    switch (context) {
      case ESideBarContext.PROJECT:
        return getIconByContext(context, isCheckout);
      case ESideBarContext.PORTAL:
        return getIconByContext(context, false);
      case ESideBarContext.PORTAL_LEVEL_STORE:
        return getIconByContext(context, false);
      default:
        return (
          <img
            src={'./assets/icons/ac-black-green-icon.png'}
            alt={`${context} icon`}
            className="w-5 h-5 object-contain"
            style={{ borderRadius: '6px' }}
          />
        );
    }
  };

  return renderIcon();
};

export default AppchargeIcon;
